export default __webpack_public_path__ + "static/media/DesktopLine2.cb6824ff.svg";